// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3OjlN","title":"ClientReferral_title__3medh","itemText":"ClientReferral_itemText__2JjZI"};